/* eslint-disable import/prefer-default-export */
export const SUPPORT_EMAIL = 'support@trialbee.com';
